import { render, staticRenderFns } from "./OtherDataOrder.vue?vue&type=template&id=ae580c7a&scoped=true"
import script from "./OtherDataOrder.vue?vue&type=script&lang=js"
export * from "./OtherDataOrder.vue?vue&type=script&lang=js"
import style0 from "./OtherDataOrder.vue?vue&type=style&index=0&id=ae580c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae580c7a",
  null
  
)

export default component.exports